import Vue from 'vue';
const bus = new Vue();

/**
 * bus事件，全局的事件至今定义在对象中
 */
export const busEvent = {
    /**
     * 全局金币可能发生了变化，关注金币的模块需要订阅此事件
     */
    GLOBAL_COIN_MAYBE_CHANGE: 'GLOBAL_COIN_MAYBE_CHANGE',
    /**
     * 暂停全局动画
     */
    PAUSE_ANIMATION: 'PAUSE_ANIMATION',
    /**
     * 播放全局动画
     */
    PLAY_ANIMATION: 'PLAY_ANIMATION',
    DISABLE_PAGE_QUIE: 'DISABLE_PAGE_QUIE',
    ENABLE_PAGE_QUIE: 'ENABLE_PAGE_QUIE',
    /**
     * 隐藏默认返回按钮
     */
    HIDE_DEFAULT_BACK_BUTTON: 'HIDE_DEFAULT_BACK_BUTTON',
    /**
     * 执行关闭挽留
     */
    EXECUTE_CLOSE_STAY_MODULE: 'EXECUTE_CLOSE_STAY_MODULE',
    /**
     * 接收页面事件变化
     */
    RECEIVE_PAGE_STATUS: 'RECEIVE_PAGE_STATUS',
    /**
     * 点击音频按钮
     */
    CLICK_AUDIO_BUTTON: 'CLICK_AUDIO_BUTTON',
    /**
     * 切换页面tab
     */
    SWITCH_PAGE_FILTER_MOUDLE: 'SWITCH_PAGE_FILTER_MOUDLE',
    /**
     * 切换页面tab (反向通知)
     */
    SWITCH_PAGE_FILTER_MOUDLE_FROM_APP: 'SWITCH_PAGE_FILTER_MOUDLE_FROM_APP',
    /**
     * 更新专题关注状态
     */
    UPDATE_SUBJECT_FOLLOW_STATUS: 'UPDATE_SUBJECT_FOLLOW_STATUS',
    /**
     * 更新一键关注按钮状态
     */
    UPDATE_ALL_SUBJECT_FOLLOW_STATUS: 'UPDATE_ALL_SUBJECT_FOLLOW_STATUS',
    /**
     * 刷新任务列表
     */
    UPDATE_TASK_REFRESH: 'UPDATE_TASK_REFRESH',
    /**
     * 中间去抖事件，主要用于功能模块完成后，延迟更新相关静态模块的任务列表
     */
    MIDDLEWARE_DEBOUNCE: 'MIDDLEWARE_DEBOUNCE',
    /**
     * 打开deeplink的引导弹框
     */
    OPEN_DEEPLINK_GUIDE: 'OPEN_DEEPLINK_GUIDE',
    /**
     * 消费KKB事件发生了
     */
    CONSUME_KKB_EVENT: 'CONSUME_KKB_EVENT',
    /**
     * 隐藏关闭挽留模块（当配置顶部导航栏时）
     */
    HIDE_CLOSE_STAY_BUTTON_WHO_NEED_HIDE: 'HIDE_CLOSE_STAY_BUTTON_WHO_NEED_HIDE',
    /**
     * 隐藏需要分享按钮
     */
    HIDE_SHARE_BUTTON_WHO_NEED_HIDE: 'HIDE_SHARE_BUTTON_WHO_NEED_HIDE',
    /**
     * 关注阶段奖励模块的模块需要订阅此事件
     */
    STAGE_AWARD_CHANGE: 'STAGE_AWARD_CHANGE',
    /**
     * 会导致奖励发生变化的模块需要发布此事件
     * 当前有：答题模块、兑换模块、抽奖模块、抽奖按钮模块、拆红包模块、拼图模块、任务模块、实时奖励模块、大富翁抽奖模块、签到模块、阶段奖励模块、访问奖励模块、多档位抽奖模块
     */
    PRIZE_SHOW_CHANGE: 'PRIZE_SHOW_CHANGE',
    /**
     * 分享任务可以被完成
     */
    SHARE_TASK_CAN_FINISH: 'SHARE_TASK_CAN_FINISH',
    /**
     * 有配置吸顶的分页筛选模块（非发现页）
     */
    HAS_TOP_FILTER_MODULE: 'HAS_TOP_FILTER_MODULE',
    /**
     * 可以获取访问奖励
     */
    CAN_GET_VISIT_PRIZE: 'CAN_GET_VISIT_PRIZE',
    /**
     * 拉票弹窗中进行了投票
     */
    CANVASSING_DIALOG_VOTED: 'CANVASSING_DIALOG_VOTED',
    /**
     * 大富翁获奖弹窗或toast提示后
     */
    PRIZE_INFORMED: 'PRIZE_INFORMED',
    /**
     * 打开奖励背包模块
     */
    OPEN_PRIZE_BACKPACK: 'OPEN_PRIZE_BACKPACK',
    /**
     * 任务容器id更新
     */
    QUEST_CONTAINER_UPDATE: 'QUEST_CONTAINER_UPDATE',
    /**
     * 应该打开头图模块
     */
    SHOULD_FIRST_OPEN_TITLE_IMG: 'SHOULD_FIRST_OPEN_TITLE_IMG',
    /**
     * 头图模块被打开
     */
    TITLE_IMG_MODULE_HAD_CLOSED: 'TITLE_IMG_MODULE_HAD_CLOSED',
    /**
     * 签到弹窗流程完成
     */
    SIGN_DIALOG_PROCESS_FINISHED: 'SIGN_DIALOG_PROCESS_FINISHED',
    /**
     * 进行一次自动领奖的检查
     */
    CHECK_AUTO_OBTAIN_PRIZE_ONCE: 'CHECK_AUTO_OBTAIN_PRIZE_ONCE',
    /**
     * 作品排行榜可能发生变化
     */
    TOPIC_RANK_MAY_CHANGE: 'TOPIC_RANK_MAY_CHANGE',
};

export default bus;
